const OVERLAY_SELECTOR = `div.overlay`;

const OVERLAY_VISIBLE_CLASS = `visible`;

const canselEvents = [
	`click`,
	`mousedown`,
	`mouseup`,
	`touch`,
	`touchstart`,
	`touchend`,
	`keypress`,
	`keydown`,
	`keyup`
]

const canselEvent = (evt) => {
	evt.preventDefault();
	evt.stopImmediatePropagation();
};

const applyListener = ( setter ) => {
	canselEvents.forEach( ( eventName ) => {
		document[setter]( eventName, canselEvent, true );
	})
};

export const disableForm = ( form ) => {
	const overlay = form.querySelector( OVERLAY_SELECTOR );
	
	form.querySelectorAll(`*`).forEach( (element) => {
		element.setAttribute( `disabled`, "true" );
		element.setAttribute( `tabIndex`, -1 );
		element.style[`pointer-events`] = `none`;
		element.style[`user-select`] = `none`;
	} );
	
	if ( overlay ) {
		overlay.classList.add( OVERLAY_VISIBLE_CLASS );
	}
	
	applyListener( `addEventListener` );
};

export const enableForm = ( form ) => {
	const overlay = form.querySelector( OVERLAY_SELECTOR );
	
	form.querySelectorAll(`*`).forEach( (element) => {
		element.removeAttribute(`disabled`);
		element.removeAttribute(`tabIndex`);
		element.style.removeProperty(`pointer-events`);
		element.style.removeProperty(`user-select`);
	} );
	
	if ( overlay ) {
		overlay.classList.remove( OVERLAY_VISIBLE_CLASS );
	}
	
	applyListener( `removeEventListener` );
};
